<template>
  <!-- Переключатель темы как на сайте Element Plus: дорожка с бегунком,
       в бегунке солнце или луна. Новая тема раскрывается кругом от точки
       нажатия (View Transitions); где браузер этого не умеет — сразу -->
  <button
    type="button"
    class="theme-switch"
    :class="{ 'theme-switch--dark': isDark }"
    role="switch"
    :aria-checked="isDark"
    :title="isDark ? 'Светлая тема' : 'Тёмная тема'"
    :aria-label="isDark ? 'Включить светлую тему' : 'Включить тёмную тему'"
    @click="toggle"
  >
    <span class="theme-switch__knob">
      <el-icon><Moon v-if="isDark" /><Sunny v-else /></el-icon>
    </span>
  </button>
</template>

<script setup>
import { Moon, Sunny } from "@element-plus/icons-vue";

const { isDark, setTheme } = useTheme();

const toggle = (event) => {
  const next = isDark.value ? "light" : "dark";
  const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

  // Скрытая вкладка не рисует кадры — переход ждал бы, и тема не менялась бы
  if (!document.startViewTransition || reduceMotion || document.visibilityState !== "visible") {
    setTheme(next);
    return;
  }

  // Круг растёт из точки нажатия до самого дальнего угла экрана
  const x = event.clientX || window.innerWidth;
  const y = event.clientY || 0;
  const radius = Math.hypot(Math.max(x, window.innerWidth - x), Math.max(y, window.innerHeight - y));

  const transition = document.startViewTransition(() => setTheme(next));
  transition.ready.then(() => {
    document.documentElement.animate(
      { clipPath: [`circle(0px at ${x}px ${y}px)`, `circle(${radius}px at ${x}px ${y}px)`] },
      { duration: 450, easing: "ease-in", pseudoElement: "::view-transition-new(root)" }
    );
  });
};
</script>

<style scoped>
.theme-switch {
  position: relative;
  flex-shrink: 0;
  width: 40px;
  height: 20px;
  padding: 0;
  border: 1px solid var(--el-border-color);
  border-radius: 10px;
  background-color: var(--el-fill-color);
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
}

.theme-switch:hover {
  border-color: var(--el-color-primary);
}

.theme-switch:focus-visible {
  outline: 2px solid var(--el-color-primary);
  outline-offset: 2px;
}

.theme-switch__knob {
  position: absolute;
  top: 1px;
  left: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: var(--el-bg-color);
  color: var(--el-text-color-regular);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  font-size: 12px;
  transition: transform 0.25s;
}

.theme-switch--dark .theme-switch__knob {
  transform: translateX(20px);
  background-color: #000;
  color: var(--el-text-color-primary);
}
</style>

<style>
/* Плавная смена темы: стандартное перекрёстное затухание выключаем,
   новый кадр открывается кругом (анимация — в ThemeSwitch.toggle) */
::view-transition-old(root),
::view-transition-new(root) {
  animation: none;
  mix-blend-mode: normal;
}
</style>
